export function getFileType(extension: string): string {
  return extension ? extension.replace('.', '').toUpperCase() : ''
}

export function downloadPDF(pdf: string, fileName: string) {
  const linkSource = `data:application/pdf;base64,${pdf}`
  const downloadLink = document.createElement('a')

  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

// Pre endpointy vracajúce binárny súbor (StreamableFile), nie base64 JSON.
export function downloadBlobAsFile(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob)
  const downloadLink = document.createElement('a')

  downloadLink.href = url
  downloadLink.download = fileName
  downloadLink.click()

  URL.revokeObjectURL(url)
}

// Vytiahne filename z `Content-Disposition` hlavičky; fallback ak hlavička chýba
// (napr. cross-origin bez `Access-Control-Expose-Headers: Content-Disposition`).
export function getFileNameFromContentDisposition(
  contentDisposition: string | null,
  fallbackFileName: string
): string {
  if (!contentDisposition) return fallbackFileName
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(contentDisposition)
  return match?.[1] ? decodeURIComponent(match[1]) : fallbackFileName
}
